import Vue from 'vue';
import App from './App';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import * as api from './utils/api';
import urls from "./config/urls";
import {Loading} from "element-ui";
import Router from 'vue-router';
import router from './router';
import * as echarts from 'echarts';
import {Message} from 'element-ui';
import Vue2OrgTree from 'vue2-org-tree';

Vue.config.productionTip = false;
Vue.prototype.$vue = Vue;
Vue.prototype.$api = api;
Vue.prototype.$urls = urls;
Vue.prototype.$load = Loading;
Vue.prototype.$echarts = echarts;

Vue.use(ElementUI);
Vue.use(Vue2OrgTree);
Vue.use(Router);

new Vue({
  el:'#app',render:h => h(App),router:router
});

Vue.prototype.$message = function(msg){
  return Message({
    message:msg,duration:1000
  });
};
Vue.prototype.$message.success = function(msg){
  return Message.success({
    message:msg,duration:1000
  });
};
Vue.prototype.$message.info = function(msg){
  return Message.info({
    message:msg,duration:1000
  });
};
Vue.prototype.$message.warning = function(msg){
  return Message.warning({
    message:msg,duration:1000
  });
};
Vue.prototype.$message.error = function(msg){
  return Message.error({
    message:msg,duration:1000
  });
};



// WEBPACK FOOTER //
// ./src/main.js